import s from "./DevicesImport.module.css"
import * as Yup from 'yup';
import scanner from './scanner.png'
import React, { useState, useEffect } from 'react';
import { useUser } from '../../Context/UserContext';
import { SubmitButtonForm } from '../shared/SubmitButtonForm'
import QRModal from "./QRModal";
import { useFormik } from 'formik';
import { TextField, FormControl, InputLabel, MenuItem, Button, Autocomplete } from '@mui/material';
import { createDeviceCs, createDevice, editDevices, editDevicesNbiot, createDeviceNbiot } from "../../Api//DevicesApi"
import { getAddressForm } from "../../Api/AddressApi"
import { ModalTemplate } from "../shared/ModalForms";
import { GroupForm } from "../Forms/NbiotForm";
import { AddressFormChirpStack, AddressFormNbiot } from "../Forms/AddressForm";
import { FormSelect } from "../shared/FormSelect";
import { FormTextField } from "../shared/FormTextField";
// import CameraComponent from "../Camera/Camera";
// import ScanModal from "./ScanModal";

const validationSchema = Yup.object({
    deveui: Yup.string()
        .matches(/^[0-9a-fA-F]{16}$/, "DevEUI must be a 16-character hexadecimal string.")
        .required("DevEUI is required."),
    appkey: Yup.string()
        .matches(/^[0-9a-fA-F]{32}$/, "AppKey must be a 32-character hexadecimal string.")
        .required("AppKey is required."),
});

const useHideMessage = (submitStatus, setSubmitStatus, setErrorMessage) => {
    useEffect(() => {
        if (submitStatus === 'success' || submitStatus === 'error') {
            const timer = setTimeout(() => {
                setSubmitStatus(null);
                setErrorMessage(null);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [submitStatus, setSubmitStatus, setErrorMessage]);
};

export const DeviceForm = () => {
    const { user } = useUser();
    const [addressList, setAddressList] = useState();
    const [scanActive, setScanActive] = useState(false);
    const [scanVolumeActive, setScanVolumeActive] = useState(false);
    const [activeField, setActiveField] = useState(null);
    const [qr, setQR] = useState(false);
    const [scan, setScan] = useState(false);
    const [filteredAddressList, setFilteredAddressList] = useState(addressList);
    const [addNew, setAddNew] = useState(false);

    const closeModal = () => {
        setScanActive(false)
        setScanVolumeActive(false)
    };

    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [openAddress, setOpenAddress] = useState(false);
    const handleOpenAddress = () => setOpenAddress(true);
    const handleCloseAddress = () => setOpenAddress(false);

    // const [openCamera, setOpenCamera] = useState(false);
    // const handleOpenCamera = () => setOpenCamera(true);
    // const handleCloseCamera = () => setOpenCamera(false);

    const formik = useFormik({
        initialValues: {
            group: '',
            address: '',
            number: '',
            start_volume: 0.0,
            deveui: '',
            appeui: '',
            appkey: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
                const data = await createDeviceCs(values, user.email);
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    const handleAddressSuccess = (newAddress) => {
        setAddNew(true);
        formik.setFieldValue('address', newAddress.id);
        handleCloseAddress();
    };

    // const handleCameraSuccess = () => {
    //     handleCloseCamera();
    // };

    useEffect(() => {
        async function fetchAddress() {
            try {
                const data = await getAddressForm("lora");
                setAddressList(data);
                setAddNew(false);
            } catch (error) {
                console.error('Error fetching address list:', error.message);
            }
        }

        fetchAddress();
    }, [addNew]);

    useEffect(() => {
        if (formik.values.group) {
            const filteredAddresses = addressList.filter(addr =>
                addr.group.some(group => group.id === formik.values.group)
            );

            setFilteredAddressList(filteredAddresses);
        } else {
            setFilteredAddressList(addressList);
        }
    }, [formik.values.group, addressList]);


    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleButtonClick = (field) => {
        setActiveField(field);
        setQR(true);
        setScanActive(true);
    };

    const handleButtonClickScan = (field) => {
        setActiveField(field);
        setScan(true);
        setScanVolumeActive(true);
    };

    const handleGroupSuccess = (group) => {
        formik.setFieldValue('group', group.id);
        handleCloseGroup();
    };

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}

            <FormControl fullWidth sx={{ marginTop: 1 }}>
                <InputLabel>Группа устройств Lora</InputLabel>
                <FormSelect formik={formik} name="group" label="Группа устройств Lora" value={formik.values.group} size="large">
                    <MenuItem value="new" onClick={handleOpenGroup}>
                        + Создать новую группу
                    </MenuItem>
                    {user.group.map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>
                <ModalTemplate
                    open={openGroup}
                    onClose={handleCloseGroup}
                >
                    <GroupForm onSuccess={handleGroupSuccess} />
                </ModalTemplate>
            </FormControl>
            <FormControl fullWidth sx={{ marginTop: 1 }}>
                <Autocomplete
                    value={(Array.isArray(filteredAddressList) &&
                        filteredAddressList.find(addr => addr.id === formik.values.address))}
                    onChange={(event, newValue) => {
                        if (newValue && newValue.id === 'new') {
                            handleOpenAddress();
                        } else {
                            formik.setFieldValue('address', newValue ? newValue.id : '');
                        }
                    }}
                    freeSolo
                    options={[{ id: 'new', label: '+ Добавить адрес' }, ...(filteredAddressList || [])]}
                    getOptionLabel={(option) =>
                        option.id === 'new' ? '' :
                            option.label || `${option.country || ''}, ${option.region || ''}, ${option.city || ''}, ${option.street || ''}, ${option.building || ''}`
                    }
                    renderInput={(params) => <TextField {...params} label="Адрес" />}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                            {option.label
                                ? option.label
                                : `${option.country || ''}, ${option.region || ''}, ${option.city || ''}, ${option.street || ''}, ${option.building || ''}`}
                        </li>
                    )}
                />
                <ModalTemplate
                    open={openAddress}
                    onClose={handleCloseAddress}
                >
                    <AddressFormChirpStack onSuccess={handleAddressSuccess} />
                </ModalTemplate>
            </FormControl>
            <FormTextField formik={formik} name={"number"} value={formik.values.number} label={"Номер квартиры"} size="large" />
            <div className={s.inputQr}>
                <FormTextField formik={formik} name={"start_volume"} value={formik.values.start_volume} label={"Начальные показания"} size="large" />
                {/* <div className={s.qrDiv}>
                    <img onClick={() => handleOpenCamera()} className={s.img} src={scanner}></img>
                </div> */}
            </div>
            {/* <ModalTemplate
                open={openCamera}
                onClose={handleCloseCamera}
            >
                <CameraComponent onSuccess={handleCameraSuccess}></CameraComponent>
            </ModalTemplate> */}

            <div className={s.inputQr}>
                <FormTextField formik={formik} name={"deveui"} value={formik.values.deveui} label={"DevEUI"} size="large" />
                <div className={s.qrDiv}>
                    <img onClick={() => handleButtonClick('deveui')} className={s.img} src={scanner}></img>
                </div>
            </div>
            <div className={s.inputQr}>
                <FormTextField formik={formik} name={"appeui"} value={formik.values.appeui} label={"AppEUI"} size="large" />
                <div className={s.qrDiv}>
                    <img onClick={() => handleButtonClick('appeui')} className={s.img} src={scanner}></img>
                </div>
            </div>
            <div className={s.inputQr}>
                <FormTextField formik={formik} name={"appkey"} value={formik.values.appkey} label={"AppKey"} size="large" />
                <div className={s.qrDiv}>
                    <img onClick={() => handleButtonClick('appkey')} className={s.img} src={scanner}></img>
                </div>
            </div>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
            {scanActive && (
                <QRModal isOpen={!!qr} closeModal={closeModal} setFieldValue={formik.setFieldValue} setScanActive={setScanActive} activeField={activeField} />
            )}
            {/* {scanVolumeActive && (
                <ScanModal isOpen={!!scan} closeModal={closeModal} setFieldValue={formik.setFieldValue} setScanActive={setScanVolumeActive} activeField={activeField} />
            )} */}

        </form>
    );
}


export const DevicesImportForm = () => {
    const [addressList, setAddressList] = useState();
    const [filteredAddressList, setFilteredAddressList] = useState(addressList);
    const { user } = useUser();
    const [addNew, setAddNew] = useState(false);

    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [openAddress, setOpenAddress] = useState(false);
    const handleOpenAddress = () => setOpenAddress(true);
    const handleCloseAddress = () => setOpenAddress(false);


    const formik = useFormik({
        initialValues: {
            group: '',
            address: '',
            file: null,
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createDevice(values);
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    const handleAddressSuccess = (newAddress) => {
        setAddNew(true);
        formik.setFieldValue('address', newAddress._id);
        handleCloseAddress();

    };

    const handleGroupSuccess = (group) => {
        formik.setFieldValue('group', group._id);
        handleCloseGroup();
    };

    useEffect(() => {
        async function fetchAddress() {
            try {
                const data = await getAddressForm("lora");
                setAddressList(data);
                setAddNew(false);
            } catch (error) {
                console.error('Error fetching address list:', error.message);
            }
        }

        fetchAddress();
    }, [addNew]);

    useEffect(() => {
        if (formik.values.group) {

            const filteredAddresses = addressList.filter(addr =>
                addr.group.some(group => group._id === formik.values.group)
            );
            setFilteredAddressList(filteredAddresses);
        } else {
            setFilteredAddressList(addressList);
        }
    }, [formik.values.group, addressList]);


    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств Lora</InputLabel>
                <FormSelect formik={formik} name="group" label="Группа устройств Lora" value={formik.values.group} size="large">
                    <MenuItem value="new" onClick={handleOpenGroup}>
                        + Создать новую группу
                    </MenuItem>
                    {user.group.map(group => (

                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>
                <ModalTemplate
                    open={openGroup}
                    onClose={handleCloseGroup}
                >
                    <GroupForm onSuccess={handleGroupSuccess} />
                </ModalTemplate>
            </FormControl>

            <FormControl fullWidth sx={{ marginTop: 1 }}>
                <Autocomplete
                    value={(Array.isArray(filteredAddressList) &&
                        filteredAddressList.find(addr => addr.id === formik.values.address))}
                    onChange={(event, newValue) => {
                        if (newValue && newValue.id === 'new') {
                            handleOpenAddress();
                        } else {
                            formik.setFieldValue('address', newValue ? newValue._id : '');
                        }
                    }}
                    freeSolo
                    options={[{ id: 'new', label: '+ Добавить адрес' }, ...(filteredAddressList || [])]}
                    getOptionLabel={(option) =>
                        option.id === 'new' ? '' :
                            option.label || `${option.city || ''}, ${option.street || ''}, ${option.building || ''}`
                    }
                    renderInput={(params) => <TextField {...params} label="Адрес" />}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                            {option.label
                                ? option.label
                                : `${option.city || ''}, ${option.street || ''}, ${option.building || ''}`}
                        </li>
                    )}
                />

                <ModalTemplate
                    open={openAddress}
                    onClose={handleCloseAddress}
                >
                    <AddressFormChirpStack onSuccess={handleAddressSuccess} />
                </ModalTemplate>
            </FormControl>
            <div className={s.inputField}>
                <input
                    accept=".xlsx, .xls, .csv"
                    id="file"
                    name="file"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        formik.setFieldValue("file", event.target.files[0]);
                    }}
                />
                <label htmlFor="file">
                    <Button variant="contained" color="primary" component="span">
                        Выберите файл
                    </Button>
                    {formik.values.file && (
                        <span className={s.fileName}>{formik.values.file.name}</span>
                    )}
                </label>
            </div>
            <SubmitButtonForm>Отправить</SubmitButtonForm>

        </form>
    );
}


export const DevicesEditForm = () => {

    const formik = useFormik({
        initialValues: {
            file: null,
        },
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
                const data = await editDevices(values.file);
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })


    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <div className={s.inputField}>
                <input
                    accept=".csv"
                    id="file"
                    name="file"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        formik.setFieldValue("file", event.target.files[0]);
                    }}
                />
                <label htmlFor="file">
                    <Button variant="contained" color="primary" component="span">
                        Выберите файл
                    </Button>
                    {formik.values.file && (
                        <span className={s.fileName}>{formik.values.file.name}</span>
                    )}
                </label>
            </div>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}


export const DevicesNbiotImportForm = () => {
    const [addressList, setAddressList] = useState();
    const [filteredAddressList, setFilteredAddressList] = useState(addressList);
    const { user } = useUser();
    const [addNew, setAddNew] = useState(false);

    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [openAddress, setOpenAddress] = useState(false);
    const handleOpenAddress = () => setOpenAddress(true);
    const handleCloseAddress = () => setOpenAddress(false);

    const formik = useFormik({
        initialValues: {
            group: '',
            address: '',
            file: null,
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createDeviceNbiot(values);
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    const handleAddressSuccess = (newAddress) => {
        setAddNew(true);
        formik.setFieldValue('address', newAddress._id);
        handleCloseAddress();
    };

    const handleGroupSuccess = (group) => {
        console.log(group);
        
        formik.setFieldValue('group', group._id);
        handleCloseGroup();
    };

    useEffect(() => {
        async function fetchAddress() {
            try {
                const data = await getAddressForm("nbiot");
                setAddressList(data);
                setAddNew(false);
            } catch (error) {
                console.error('Error fetching address list:', error.message);
            }
        }
        fetchAddress();
    }, [addNew]);

    useEffect(() => {
        if (formik.values.group) {
            const filteredAddresses = addressList.filter(addr =>
                addr.group.some(group => group._id === formik.values.group)
            );
            setFilteredAddressList(filteredAddresses);
        } else {
            setFilteredAddressList(addressList);
        }
    }, [formik.values.group, addressList]);

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    console.log(formik);

    return (
        <form onSubmit={formik.handleSubmit}>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств NBIoT</InputLabel>
                <FormSelect formik={formik} name="group" label="Группа устройств NBIoT" value={formik.values.group} size="large">
                    <MenuItem value="new" onClick={handleOpenGroup}>
                        + Создать новую группу
                    </MenuItem>
                    {[...user.group].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(group => (
                        <MenuItem value={group.id} key={group._id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>

                <ModalTemplate
                    open={openGroup}
                    onClose={handleCloseGroup}
                >
                    <GroupForm onSuccess={handleGroupSuccess} />
                </ModalTemplate>
            </FormControl>
            <FormControl fullWidth sx={{ marginTop: 1 }}>
                <Autocomplete
                    value={(Array.isArray(filteredAddressList) &&
                        filteredAddressList.find(addr => addr.id === formik.values.address))}
                    onChange={(event, newValue) => {
                        if (newValue && newValue.id === 'new') {
                            handleOpenAddress();
                        } else {
                            formik.setFieldValue('address', newValue ? newValue._id : '');
                        }
                    }}
                    freeSolo
                    options={[{ id: 'new', label: '+ Добавить адрес' }, ...(filteredAddressList || [])]}
                    getOptionLabel={(option) =>
                        option.id === 'new' ? '' :
                            option.label || `${option.city || ''}, ${option.street || ''}, ${option.building || ''}`
                    }
                    renderInput={(params) => <TextField {...params} label="Адрес" />}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                            {option.label
                                ? option.label
                                : `${option.city || ''}, ${option.street || ''}, ${option.building || ''}`}
                        </li>
                    )}
                />

                <ModalTemplate
                    open={openAddress}
                    onClose={handleCloseAddress}
                >
                    <AddressFormNbiot onSuccess={handleAddressSuccess} />
                </ModalTemplate>
            </FormControl>
            <div className={s.inputField}>
                <input
                    accept=".xlsx, .xls, .csv"
                    id="file"
                    name="file"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        formik.setFieldValue("file", event.target.files[0]);
                    }}
                />
                <label htmlFor="file">
                    <Button variant="contained" color="primary" component="span">
                        Выберите файл
                    </Button>
                    {formik.values.file && (
                        <span className={s.fileName}>{formik.values.file.name}</span>
                    )}
                </label>
            </div>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>

    );
}

export const DevicesNbiotEditForm = () => {

    const formik = useFormik({
        initialValues: {
            file: null,
        },
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
                const data = await editDevicesNbiot(values.file);
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <div className={s.inputField}>
                <input
                    accept=".csv"
                    id="file"
                    name="file"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        formik.setFieldValue("file", event.target.files[0]);
                    }}
                />
                <label htmlFor="file">
                    <Button variant="contained" color="primary" component="span">
                        Выберите файл
                    </Button>
                    {formik.values.file && (
                        <span className={s.fileName}>{formik.values.file.name}</span>
                    )}
                </label>
            </div>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}